export enum PRIORITY_ENUM {
  ABSOLUTE = 'absolute',
  RELATIVE = 'relative',
}
